import React, { useState, useEffect } from 'react';
import { ExternalLink } from 'lucide-react';

interface OpenInAppButtonProps {
  publicCode: string;
}

/**
 * Smart "Open in App" button that:
 * - Attempts to open the iOS app with a custom URL scheme
 * - Falls back gracefully if app is not installed
 * - Only shows on mobile devices
 */
const OpenInAppButton: React.FC<OpenInAppButtonProps> = ({ publicCode }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Detect if user is on mobile
    const mobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setIsMobile(mobile);
  }, []);

  const handleOpenInApp = () => {
    if (!publicCode) return;

    // Custom URL scheme for the iOS app
    const appUrl = `starttime://t/${publicCode}`;

    // Attempt to open the app
    window.location.href = appUrl;

    // After a short delay, if still on this page, the app probably isn't installed
    // Safari will show an error dialog automatically
    setTimeout(() => {
      // Could show a custom message here if needed
      console.log('App may not be installed');
    }, 1000);
  };

  // Don't show on desktop
  if (!isMobile) return null;

  return (
    <button
      onClick={handleOpenInApp}
      className="flex items-center justify-center gap-2 w-full px-4 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold shadow-lg transition-colors"
    >
      <ExternalLink size={20} />
      <span>Open in App</span>
    </button>
  );
};

export default OpenInAppButton;
